import React from 'react';
import { LabelSection } from './filter-drawer-rules-section.styles';
import { Tag } from './tag/tag';
import { useCampaignFilterRules } from '../../rules';
import { useCampaignFilterInterface } from '../../interface';
import { getText } from './filter-drawer-rules-section.utils';
import {
    CAMPAIGNS_FILTER_AUTO_TEST_IDS,
    CAMPAIGNS_FILTER_TEST_IDS,
} from '../../campaigns-filter.constants';

export const FilterDrawerRulesSection = () => {
    const { rules } = useCampaignFilterRules();
    const { onClickRemoveRule } = useCampaignFilterInterface();

    return (
        <LabelSection>
            {rules.map((rule) => {
                const ruleText = getText(rule);
                return (
                    <Tag
                        key={ruleText}
                        text={ruleText}
                        onClose={() => { onClickRemoveRule(rule); }}
                        dataTestId={CAMPAIGNS_FILTER_TEST_IDS.TAG}
                        dataAutoTestId={CAMPAIGNS_FILTER_AUTO_TEST_IDS.TAG_CLOSE}
                    />
                );
            })}
        </LabelSection>
    );
};
